import Navbar from "components/Navbar"
import Footer from "components/Footer";
import { useSelector } from "react-redux";
import MobileNavbar from "components/MobileNavbar";
import MobileFooter from "components/MobileFooter";
import SeminarPage from "components/Seminar/SeminarPage"


function Seminars () {

    const isMobile = useSelector(state => state.windowSize.isMobile);

    return(
        <>
        {isMobile ? (
            <>
            <MobileNavbar />
            <SeminarPage />
            <MobileFooter />
            </>
        ) : (
            <>
            <Navbar />
            <SeminarPage />
            <Footer />
            </>
        )}
        </>
    )
}

export default Seminars